/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable-next-line */
import React, { Component } from "react";
import { Helmet } from "react-helmet-async";
import { Casestudy } from "json/ProductsPageData";

import Header1 from "parts/Header1";
import HeroCase from "partsproducts/HeroCase";
import Casestudys from "partsproducts/CasesStudy";
import Footer from "parts/Footer";
import CtaCase from "partsproducts/CtaCase";

export default class CasesPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Helmet>
          <title>
            Case Studies | Nube iO – Real Building Automation Result
          </title>
          <meta
            name="description"
            content="See how facility teams and building owners use Nube iO to gain control, meet compliance, and improve comfort across their portfolios, in their own words."
          />
          <meta
            name="keywords"
            content="Nube iO case studies, building automation results, customer success"
          />
          <link rel="canonical" href="https://nube-io.com/case-studies/ " />
          <meta
            property="og:title"
            content="Case Studies | Nube iO – Real Building Automation Result"
          />
          <meta
            property="og:description"
            content="See how facility teams and building owners use Nube iO to gain control, meet compliance, and improve comfort across their portfolios, in their own words."
          />
          <meta property="og:url" content="https://nube-io.com/case-studies/" />
        </Helmet>

        <Header1 />
        <HeroCase />
        <Casestudys data={Casestudy} />
        <CtaCase />
        <Footer />
      </>
    );
  }
}
